module.exports = __webpack_public_path__ + "assets/img/3-mobile.0abaedb5.png";